import { render, staticRenderFns } from "./ToTopArrow.vue?vue&type=template&id=d580e074&scoped=true&"
import script from "./ToTopArrow.vue?vue&type=script&lang=js&"
export * from "./ToTopArrow.vue?vue&type=script&lang=js&"
import style0 from "./ToTopArrow.vue?vue&type=style&index=0&id=d580e074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d580e074",
  null
  
)

export default component.exports